<template>
  <div class="container-cidades">
    
    <div class="row"  v-if="showBairros == false">

<div class="col-sm-12">
      <h1>Gerenciamento de Cidades </h1><br>
    </div>

          <div class="form-group col-sm-4">
          <label>Nome da cidade:</label>
          <input type="text" name="cidade" class="form-control" value="" v-model="cidade">
        </div>

          <button @click="addCidade()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+ADICIONAR</button>

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

    </div><!-- row -->


    <div class="row"  v-if="showBairros == false">

 <table class="col-sm table table-striped table-dark">
  <thead>
    <tr>
      
      <th scope="col">Cidade</th>
      <th scope="col">Gerenciar</th>
      <th scope="col">Deletar</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in cidades" :key="item.CID_ID" >
    
      <td>
         <input type="text" :data-codigo="item.CID_ID" name="setCidade" @keyup.enter="updateCidade" class="form-control" :value="item.CID_NOME">
       </td>
      <td><button type="button" class="btn btn-warning" @click="goToBairros(item.CID_ID)">Gerenciar Bairros</button></td>
      
      <td><button type="button" :data-codigo="item.CID_ID" class="btn btn-danger" @click="deleteCidade">Deletar</button></td>
    </tr>
   
  </tbody>
</table>

    </div><!-- row table -->

<Bairro :cidade="selecionado" v-if="showBairros"></Bairro>
<button type="button" class="btn btn-warning"  v-if="showBairros" @click="voltar()">VOLTAR</button>

  </div>
</template>

<script>
import axios from 'axios'
import Bairro from '../views/Bairro.vue'

export default {
  name: 'Cidade',
  components: {Bairro},
  data(){
      return {
          cidades:[],
          cidade:'',
          selecionado: 0,
          showBairros:false,
          loading: false
      }
  },
 

methods:{
    addCidade(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/novaCidade',{cidade:this.cidade})
          .then( () => this.getCidades())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;this.cidade = ''})
      },


    getCidades(){
          this.loading = true;
          axios
          .get('https://www2.royaljardim.com.br/sistema/welcome/getCidades')
          .then(response => this.cidades = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    updateCidade(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/setCidade',{cidade:event.target.value,id:codigo})
          .then( () =>  this.getCidades())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },

    deleteCidade(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/deleteCidade',{id:codigo})
          .then( () =>  this.getCidades())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },

    goToBairros(id){
      this.selecionado = id;
      this.showBairros = true;
    },

    voltar(){
       this.showBairros = false;
    }

},
  

  mounted () {
   this.getCidades()
  }



}
</script>